/*
 * Public API Surface of core-socket
 */

export * from './lib/core-socket.service';
export * from './lib/core-socket.module';
export * from './lib/core-connection.properties';
